<template>
  <Modal v-model="open" :title="title">
    <Form
      ref="formItem"
      :model="formItem"
      :label-width="80"
      :rules="ruleValidate"
    >
      <FormItem label="账号" prop="us">
        <Input v-model="formItem.us" placeholder="请输入账号" clearable />
      </FormItem>
      <FormItem label="密码" prop="ps">
        <Input
          v-model="formItem.ps"
          type="password"
          placeholder="请输入密码"
          clearable
        />
      </FormItem>
      <FormItem label="性别">
        <RadioGroup v-model="formItem.sex">
          <Radio :label="0">男</Radio>
          <Radio :label="1">女</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="状态">
        <i-switch v-model="formItem.state" />
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel('formItem')">关闭</Button>
      <Button type="primary" :loading="loading" @click="ok('formItem')">
        提交
      </Button>
    </div>
  </Modal>
</template>
<script>
// 引入用于添加用户的API方法
import { usersAdd } from '@/api/user'

export default {
  name: 'UsersAddUpdate', // 组件名称
  data() {
    return {
      // 表单数据对象
      formItem: {
        us: '', // 用户账号
        ps: '', // 用户密码
        sex: 1, // 用户性别，默认为1（可能表示男性）
        state: true, // 用户状态，默认为true（可能表示启用状态）
      },
      // 表单验证规则
      ruleValidate: {
        us: [{ // 账号验证规则
          required: true, // 必填项
          message: '请输入账号', // 错误消息
          trigger: 'blur' // 触发验证的事件（失去焦点时）
        }],
        ps: [{ // 密码验证规则
          required: true, // 必填项
          message: '请输入密码', // 错误消息
          trigger: 'blur' // 触发验证的事件（失去焦点时）
        }],
      },
      // 控制模态框的显示状态
      open: false,
      // 模态框标题
      title: '用户添加',
      // 提交按钮的加载状态
      loading: false,
    }
  },
  methods: {
    // 初始化模态框的方法
    init() {
      this.title = '用户添加' // 设置模态框标题
      this.open = true // 显示模态框
    },
    // 处理表单提交的方法
    ok(name) {
      // 使用表单验证
      this.$refs[name].validate((valid) => {
        if (!valid) return // 如果验证失败，直接返回
        this.loading = true // 设置提交按钮为加载状态
        // 深拷贝表单数据，以便发送到后端
        const postData = JSON.parse(JSON.stringify(this.formItem))
        // 调用API方法添加用户
        usersAdd(postData)
          .then((res) => {
            this.loading = false // 重置提交按钮状态
            if (res.data.code === 200) { // 如果响应码为200，表示成功
              this.$Message.success('商品添加成功') // 显示成功消息
              this.cancel('formItem') // 重置表单
              this.$emit('reload') // 触发reload事件，可能用于重新加载数据
            } else {
              this.$Message.error(res.data.msg) // 显示错误消息
            }
          })
          .catch((err) => {
            this.loading = false // 重置提交按钮状态
            this.$Message.error(err) // 显示错误消息
          })
      })
    },
    // 关闭模态框并重置表单的方法
    cancel(name) {
      // 重置表单数据
      this.formItem = {
        us: '',
        ps: '',
        sex: 1,
        state: true,
      }
      // 调用表单的resetFields方法重置验证状态
      this.$refs[name].resetFields()
      this.open = false // 隐藏模态框
    },
  },
  mounted() {
    // 组件挂载后执行的钩子函数，当前为空
  },
}
</script>

